import classNames from "classnames";
import { Ref } from "react";

import styles from "./FormInputCheckbox.module.css";

const FormInputCheckbox: React.FC<FormInputCheckboxProps> = ({
  name,
  id,
  label,
  error,
  inputRef,
  className,
  required,
  ...props
}) => {
  const referenceId = id || name;
  return (
    <div className={className}>
      <label
        className={classNames(styles.label, {
          [styles.labelDisabled]: props.disabled,
        })}
      >
        <input
          className={styles.input}
          type="checkbox"
          name={name}
          aria-invalid={!!error}
          aria-describedby={error && `${referenceId}_error`}
          id={id}
          ref={inputRef}
          {...props}
        />
        <svg viewBox="0 0 16 16" className={styles.icon}>
          <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" />
          <path d="M4 8.5L6.66667 11L12 6" className={styles.iconCheck} />
          <path d="M3 8.25h10" className={styles.iconIndeterminate} />
        </svg>
        <p>
          {required && <span aria-hidden={true}>*</span>} {label}
        </p>
      </label>

      {error && (
        <p id={`${referenceId}_error`} className={styles.error}>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormInputCheckbox;

export type FormInputCheckboxProps = {
  label: JSX.Element | string;
  name: string;
  id?: string;
  error?: string;
  required?: boolean;
  inputRef?: Ref<HTMLInputElement>;
} & Omit<React.HTMLProps<HTMLInputElement>, "label">;
